<template>
  <div class="flex md:justify-center">
    <input
      v-model="searchQuery"
      ref="inputRef"
      type="text"
      :placeholder="$t('globals.search_placeholder')"
      class="w-full max-w-xl md:text-lg md:px-6 py-2 md:y-4 focus:outline-none"
      @keydown.enter="emit('onEnter')"
    />
  </div>
</template>

<script setup lang="ts">
  import { ref, watch } from 'vue';
  import { useRoute, useRouter } from 'vue-router';

  const emit = defineEmits<{ (e: 'onEnter'): void }>();

  const searchQuery = ref('');
  const inputRef = ref<HTMLInputElement | null>(null);
  const route = useRoute();
  const router = useRouter();

  if (route.query.q && typeof route.query.q === 'string') {
    searchQuery.value = route.query.q;
  }

  watch(searchQuery, val => {
    router.replace({
      path: '/',
      query: { q: val || undefined },
    });
  });

  function focusInput() {
    if (inputRef.value) {
      setTimeout(() => {
        inputRef.value?.focus();
      }, 250);
    }
  }

  function clearInput() {
    searchQuery.value = '';
  }

  defineExpose({
    focusInput,
    clearInput,
  });
</script>
